module.exports = __webpack_public_path__ + "img/slide1_10.175cc7b4.png";